angular.module('bmsApp.fees')
	.controller('LicenseBreakdownModalCtrl', LicenseBreakdownModalCtrl);

LicenseBreakdownModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'fee',
	'readonlyForm',
	'$modalInstance',
];

function LicenseBreakdownModalCtrl($scope, $state, $q, fee, readonlyForm, $modalInstance) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		breakdown: {},
	});

	function calculate() {
		self.breakdown.local_sales_total = (parseFloat(self.breakdown.local_sales_monthly_billing) || 0) +
			(parseFloat(self.breakdown.local_sales_add_ons) || 0) +
			(parseFloat(self.breakdown.local_sales_consumables) || 0) +
			(parseFloat(self.breakdown.local_sales_sub_contractor) || 0);

		self.breakdown.national_sales_total = (parseFloat(self.breakdown.national_sales_monthly_billing) || 0) +
			(parseFloat(self.breakdown.national_sales_add_ons) || 0) +
			(parseFloat(self.breakdown.national_sales_consumables) || 0) +
			(parseFloat(self.breakdown.national_sales_sub_contractor) || 0);

		self.breakdown.local_cost_total = (parseFloat(self.breakdown.local_cost_add_ons) || 0) +
			(parseFloat(self.breakdown.local_cost_consumables) || 0) +
			(parseFloat(self.breakdown.local_cost_sub_contractor) || 0);

		self.breakdown.national_cost_total = (parseFloat(self.breakdown.national_cost_add_ons) || 0) +
			(parseFloat(self.breakdown.national_cost_consumables) || 0) +
			(parseFloat(self.breakdown.national_cost_sub_contractor) || 0);

		self.breakdown.monthly_billing_total = self.breakdown.local_sales_total + self.breakdown.national_sales_total;
		
		self.breakdown.add_ons_total = ((parseFloat(self.breakdown.local_sales_add_ons) || 0) + (parseFloat(self.breakdown.national_sales_add_ons) || 0)) -
			(parseFloat(self.breakdown.local_cost_add_ons) || 0) - (parseFloat(self.breakdown.national_cost_add_ons) || 0);

		self.breakdown.consumables_total = ((parseFloat(self.breakdown.local_sales_consumables) || 0) + (parseFloat(self.breakdown.national_sales_consumables) || 0)) -
			(parseFloat(self.breakdown.local_cost_consumables) || 0) - (parseFloat(self.breakdown.national_cost_consumables) || 0);

		self.breakdown.sub_contractor_total = ((parseFloat(self.breakdown.local_sales_sub_contractor) || 0) + (parseFloat(self.breakdown.national_sales_sub_contractor) || 0)) -
			(parseFloat(self.breakdown.local_cost_sub_contractor) || 0) - (parseFloat(self.breakdown.national_cost_sub_contractor) || 0);

		self.breakdown.total_fee = (self.breakdown.local_sales_total + self.breakdown.national_sales_total) - self.breakdown.local_cost_total - self.breakdown.national_cost_total;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.onInit = () => {
		self.readonly = readonlyForm;
		self.fee = fee;
		if (!angular.isObject(fee.license_breakdown)) {
			angular.extend(fee, {
				license_breakdown: {},
			});
			self.breakdown = angular.copy(fee.license_breakdown);

		}
		else {
			self.breakdown = angular.copy(fee.license_breakdown);
			calculate();
		}
	};

	handlers.onCalculate = () => {
		calculate();
	};

	handlers.onCancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.submitZeroClick = function() {
		angular.extend(fee, {
			license_breakdown: {
				total_fee: 0
			}
		});
		$modalInstance.close(fee);
	};

	handlers.submitClick = function () {
		angular.extend(fee, {
			license_breakdown: self.breakdown,
		});
		$modalInstance.close(fee);
	};
}